import React from "react";
import { connect } from "react-redux";

import { getPath } from "../../../utils";

const Permission = (props) => {
  let { requiredPerms, optionalPerms, allMenuActions, notAllowedText } = props;

  const require = requiredPerms || [];
  const optional = optionalPerms || [];

  const evaluatePerms = (reqPerms, optPerms) => {
    let reqPermsEval = true,
      optPermsEval = true;

    if (getPath(reqPerms, "length", -1) > 0) {
      reqPermsEval = reqPerms.reduce(
        (accumulator, curVal) =>
          accumulator && getPath(allMenuActions, curVal, false),
        true
      );
    }

    if (getPath(optPerms, "length", -1) > 0) {
      optPermsEval = optPerms.reduce(
        (accumulator, curVal) =>
          accumulator || getPath(allMenuActions, curVal, false),
        false
      );
    }

    return reqPermsEval && optPermsEval;
  };

  const hasPermissions = evaluatePerms(require, optional);
  if (hasPermissions === true) {
    return props.children;
  }
  return notAllowedText || "";
};

const mapStateToProps = (state) => {
  const { MenuActions } = state;
  return {
    allMenuActions: MenuActions.allMenuActions,
  };
};

export default connect(mapStateToProps, {})(Permission);
